module.exports = __webpack_public_path__ + "img/AMR.a344a8b8.jpg";